// Per-tour customer reviews/testimonials, keyed by Rezdy productCode.
// Sourced from TripAdvisor. Each entry maps a productCode to an array of reviews.
// The TourReviews component renders a section only when an entry exists for the
// tour's productCode, so adding a new tour's reviews is purely additive here.
//
// Review fields:
//   title   - short headline (TripAdvisor review title)
//   author  - reviewer name (optional; omitted line when absent)
//   date    - human-readable date string as shown on the source
//   rating  - star rating out of 5 (defaults to 5 if omitted)
//   content - the review body

export const tourReviews = [
	{
		// 2 day | 1 night - Cradle Mt & Wineglass Bay, overnight in Launceston
		productCode: 'P0QKC2',
		reviewUrl:
			'https://www.tripadvisor.com/AttractionProductReview-g255097-d33245140-2_day_Cradle_Mountain_and_Wineglass_Bay-Hobart_Greater_Hobart_Tasmania.html',
		reviews: [
			{
				title: "Irish couple's 2 day Tasmania tour",
				date: 'Jan 13, 2026',
				rating: 5,
				content:
					'Myself and my boyfriend Jack booked the two day tour from Hobart to Launcestown stopping at Cradle Mountain and Wineglass Bay. Our tour guide, Mark, was exceptional. He continually addressed us by name and asked questions about us, making us feel very comfortable. He had excellent knowledge about Tasmania, as well as other countries including our own (Ireland) and others’ on the tours home countries (India, Japan and Switzerland). He went above and beyond to meet our needs for whatever we wanted or needed at any stage during the tour. Not only did he provide great knowledge, he also provided great humour and sing songs! We thoroughly enjoyed our time and think that Mark was one of the main reasons why we loved every moment of it! Thank you Mark for giving us an experience of a lifetime!'
			},
			{
				title: 'Tassie Tours is the best way to see Tasmania',
				date: 'May 18, 2026',
				rating: 5,
				content:
					"A wonderful experience starting from booking through viator, to working with the Tassie Tours office staff to figure out lodging options, to the amazing guides, this was a great way to explore Tasmania. They managed to fit so much into two days and yet it didn't feel rushed or overdone. Mark and Jodi were the best guides you could hope for. They went above and beyond to make this an amazing trip and one I will never forget."
			},
			{
				title: 'Wonderful highlights of northeastern Tasmania',
				date: 'May 28, 2026',
				rating: 5,
				content:
					'A fantastic 2-day excursion in nature with guided walks, description of the flora and fauna, and beautiful sights. Gray was an amazing guide. He was friendly, kind, and very knowledgeable about the history of the places we visited and wonderful spots for photos, including for wombats, wallabies, pademelons, wrens, and more. It was a great way to experience the northern coast of Tasmania!'
			}
		]
	},
	{
		// Hobart Highlights Day Tour
		productCode: 'PNVP8M',
		reviewUrl:
			'https://www.tripadvisor.com/AttractionProductReview-g255097-d13275507-Hobart_Highlights_Day_Tour-Hobart_Greater_Hobart_Tasmania.html',
		reviews: [
			{
				title: 'Awesome day',
				date: 'Apr 21, 2026',
				rating: 5,
				content:
					'Thanks for an awesome day exploring your beautiful city. So much seen, from mountains to animals, Tammy was awesome, friendly and knowledgeable. Booking process and confirmations great! Highly recommended!!'
			},
			{
				title: 'Tour Experience',
				date: 'Feb 24, 2026',
				rating: 5,
				content:
					'Our tour around Mount Wellington, Richmond, and the Hobart city highlights was both enjoyable and well-organised. The tour guide was knowledgeable, approachable, and ensured everyone felt included. A well-executed experience with strong attention to customer satisfaction.'
			},
			{
				title: 'Mark is so knowledgeable!',
				date: 'Jun 14, 2026',
				rating: 5,
				content:
					'Mark is so knowledgeable! I learnt facts I never would have learnt if I went by myself. The experience was also not rigid. We are allowed to step out of the van on our own and explore each place to our liking for around 1.5h. So that gave everyone on the trip a chance to connect with each other too. I would definitely book other tours with them!'
			}
		]
	},
	{
		// Cradle Mountain Explorer: Hobart to Launceston
		productCode: 'PCBKLS',
		reviewUrl:
			'https://www.tripadvisor.com/AttractionProductReview-g255097-d15750800-Cradle_Mountain_Hobart_to_Launceston_Day_Tour-Hobart_Greater_Hobart_Tasmania.html',
		reviews: [
			{
				title: 'Great day travelling to Cradle Mountain with Maddy',
				date: 'Mar 17, 2026',
				rating: 5,
				content:
					'The tour started with Maddy collecting us from near our accommodation and she made the tour perfect, from her wide knowledge of the different towns along the way to the plants and wild life we came across. An excellent tour guide.'
			},
			{
				title: 'Great Cradle Mountain Day Trip with Tassie Tours!',
				date: 'Nov 17, 2025',
				rating: 5,
				content:
					'I joined the Hobart–Cradle Mountain–Launceston day tour with Tassie Tours and had an excellent experience. Our driver-guide was very professional and kind, driving over 10 hours and still keeping everyone comfortable. He shared great insights along the way and even drove the vehicle right into the national park, which was super convenient. Despite the cloudy and rainy weather, I still saw the beautiful Cradle Mountain and some cute wombats. A very worthwhile tour - highly recommend this company!'
			},
			{
				title: 'One of the memorable trip',
				date: 'Apr 8, 2026',
				rating: 5,
				content:
					'Excellent! Specially, our Tour Guide, Mark, was super friendly, helpful and managed the whole tour efficiently. He is knowledgeable person with lots of experiences & information. Mark also kept each and every person on the bus engaged with interacting with each one individually, throughout the tour. Instead of a boring hours-long tour, it became something where we learned while we enjoyed enormously. Kudos to Mark.'
			}
		]
	},
	{
		// A Day At Wineglass Bay
		productCode: 'PNNK81',
		reviewUrl:
			'https://www.tripadvisor.com/AttractionProductReview-g255097-d33058082-A_Day_At_Wineglass_Bay-Hobart_Greater_Hobart_Tasmania.html',
		reviews: [
			{
				title: 'Loved!',
				date: 'Apr 28, 2026',
				rating: 5,
				content:
					'Such a great day trip! Tammy was a hoot – knowledgeable along the way and also made it fun – bonus points for all the chances for toilet breaks (this is so underrated for tours and so appreciated!!). Definetly recommend!'
			},
			{
				title: 'INCREDIBLE',
				date: 'Feb 10, 2026',
				rating: 5,
				content:
					"The most amazing tour of my life. The staff were incredible. I loved the multiple hike options and the thorough location information presented by the guide. It was relaxed and tailored to the interests and needs of the guests. Beautiful energy and friendships made for a life time. You won't want to miss this opportunity."
			},
			{
				title: 'Great day at wine glass bay',
				date: 'Jan 28, 2026',
				rating: 5,
				content:
					"The wine glass bay tour was outstanding. Great customer service and communication about the options and different itinerary. Our tour guide bryony was outstanding with great pieces of information on the drive and while we were at the wine glass bay itself. The tour is also not just wine glass bay with options of seeing a lighthouse aswell as another beach aswell. I was picked up right outside my accommodation at the YHA in a prompt and efficient manner. Couldn't recommend this enough!"
			}
		]
	},
	{
		// Hastings Caves, Tahune Airwalk and the Huon tasting trail
		productCode: 'PTC0KJ',
		reviewUrl:
			'https://www.tripadvisor.com/AttractionProductReview-g255097-d28175180-Hastings_Caves_Tahune_Airwalk_and_the_Huon_Tasting_Trail-Hobart_Greater_Hobart_Tas.html',
		reviews: [
			{
				title: 'It was a wonderful trip in Tasmania',
				date: 'May 21, 2026',
				rating: 5,
				content:
					"Our guide, Skype, was very knowledgeable and pleasant. The tour was very comprehensive, taking us up to the trees at the Tahune Airwalk, down into Hastings Cave, and finishing with a delicious apple pie in Frank's. It was a wonderful experience."
			},
			{
				title: 'Pasqual provided great insight',
				date: 'Jan 26, 2026',
				rating: 5,
				content:
					'Pasqual provided great insight into history, fauna and flora during long stretches of driving. Caves and skywalk are breathtaking but the pie stop at the end topped off the experience. Lots of steps in the caves, but spaced out – average fitness required.'
			},
			{
				title: 'Tahune Airwalk 10/10',
				date: 'Feb 15, 2026',
				rating: 5,
				content:
					"Fantastic experience, our driver/guide Briony was so friendly and personable. The caves were amazing and even with 250 stairs in and 250 back, it wasn't fast paced. I'm not a fan of stairs but the pacing of the tour made the stairs very manageable. Best apple pie I've ever had at Franks on the way back."
			}
		]
	},
	{
		// Bruny Island Day Tour
		productCode: 'P18ZC5',
		reviewUrl:
			'https://www.tripadvisor.com/AttractionProductReview-g255097-d12942865-Full_Day_Guided_Bruny_Island_Tour_from_Hobart-Hobart_Greater_Hobart_Tasmania.html',
		reviews: [
			{
				title: 'Gorgeous Day at Bruny Island',
				date: 'Apr 21, 2026',
				rating: 5,
				content:
					'The day tour to Bruny was A++ with our superstar driver/tour guide Gray! He was so entertaining, friendly and accommodating too! Gave us plenty of time to spend at each stop, and kindly agreed to fulfill our request to stop at the famous roadside refrigerator "bakery" where most of us picked up some gorgeous sourdough. The whole day was well planned out and sequenced to end with a sweet treat at Bruny Island Honey!!'
			},
			{
				title: 'Fantastic day exploring Bruny',
				date: 'Jun 8, 2026',
				rating: 5,
				content:
					"Fantastic day exploring Bruny! Our driver Mark was a delightful chap and very knowledgeable. (Not to mention full of wit!). Loved both sides of the island but particularly the area on South Bruny near the lighthouse. You'd swear you were in Iceland! Totally recommended to do this tour!"
			},
			{
				title: 'Wonderful day tour',
				date: 'May 6, 2026',
				rating: 5,
				content:
					'We had an absolutely lovely time with Jodi! Another tour had fallen through and we booked last minute; very glad we did. She was knowledgeable, funny, and a delightful guide! Tour itself was also a great bite sized roundup of the wonders of Bruny, really packed a ton in for a day and had us home in time for dinner. Highly recommend!'
			}
		]
	},
	{
		// Port Arthur, Tasman Sights and Harbour Cruise
		productCode: 'PJHLE0',
		reviewUrl:
			'https://www.tripadvisor.com/AttractionProductReview-g255097-d15059333-Port_Arthur_and_Tasman_Sights_with_Harbour_Cruise-Hobart_Greater_Hobart_Tasmania.html',
		reviews: [
			{
				title: 'Our day at Port Arthur – a piece of history came alive for us',
				date: 'May 9, 2026',
				rating: 5,
				content:
					'Really enjoyed the tour with Rob. His enthusiasm for all the places and sights that he was showing us made the entire experience more meaningful and a delight. All the sights are so well maintained and it’s quite simple for first timers like us to move around them. Our tour guides explanation made it so much easier. Well planned with enough time to go around each place on the itinerary. I would definitely recommend this to my friends and family. Thank you, Tassie Tours and Rob.'
			},
			{
				title: 'Friendly, funny and so knowledgeable!',
				date: 'Apr 27, 2026',
				rating: 5,
				content:
					'Mark was the best tour guide of any trip I have ever taken. He was so knowledgeable, friendly and funny. He knew all the best places to take photos from and told us very interesting details and facts regarding Tasmania. I would book any tour with Mark. You will be so happy you did!'
			},
			{
				title: 'Informative, Entertaining, and Unforgettable',
				date: 'Apr 21, 2026',
				rating: 5,
				content:
					'Bryony was an outstanding tour guide-knowledgeable, engaging, and full of interesting insights. She brought the history of Port Arthur to life with her informative storytelling, while her great sense of humour kept the experience enjoyable and relaxed. The site itself is incredibly rich in history, and Bryony’s guidance made it even more meaningful. A memorable and worthwhile tour from start to finish.'
			}
		]
	}
];
